var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      { staticClass: "action-option", on: { click: _vm.updateCfdiStatus } },
      [
        _c("BIcon", {
          staticClass: "action-option-icon",
          attrs: { icon: "autorenew" }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }